import { useState } from 'react';

export function useContractAdvanced() {
  const [showAdvancedActions, setShowAdvancedActions] = useState(false);
  const [advancedMenuPosition, setAdvancedMenuPosition] = useState({ top: 0, left: 0 });

  return {
    showAdvancedActions, setShowAdvancedActions,
    advancedMenuPosition, setAdvancedMenuPosition,
  };
}
